import React, { useEffect, useState } from "react";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import { ReactComponent as People } from "../../assets/img/people.svg";
import { BASE_URL } from "../../Config/api.config";
import useLocalStorage from "../../Hooks/useLocalStorage";
import Statistics from "./Statistics";

ChartJS.register(ArcElement, Tooltip, Legend);

const ControlDashboard = () => {
  const [adminData] = useLocalStorage("adminData", "");
  const [statsData, setStatsData] = useState({ showClients: "all" });
  const [clientData, setClientData] = useState({});

  // Fecha hoy y hace 15 días
  const today = new Date();
  const fifteenDaysAgo = new Date();
  fifteenDaysAgo.setDate(today.getDate() - 15);

  const formatDate = (d) => d.toISOString().slice(0, 10);

  const [chartData, setChartData] = useState({
    date_start: formatDate(fifteenDaysAgo),
    date_end: formatDate(today),
    fetchedData: {},
    days: [], // array de fechas para la línea
  });

  // ---------------------- Utility ----------------------
  const getDaysArray = (start, end) => {
    const arr = [];
    let dt = new Date(start);
    const endDate = new Date(end);
    while (dt <= endDate) {
      arr.push(dt.toISOString().slice(0, 10));
      dt.setDate(dt.getDate() + 1);
    }
    return arr;
  };

  // ---------------------- Fetch Functions ----------------------
  const getAllClients = (param = "all") => {
    fetch(
      `${BASE_URL}adm.clients${
        param === "all"
          ? ""
          : param === "validated"
          ? "?validated=1"
          : "?active=1"
      }`,
      { method: "GET", headers: { Authorization: `Bearer ${adminData.uid}` } }
    )
      .then((res) => res.json())
      .then((data) => {
        if (param === "all") {
          setStatsData((prev) => ({
            ...prev,
            clientsType: data.result.clientsType,
          }));
        } else if (param === "validated") {
          setStatsData((prev) => ({
            ...prev,
            validatedStatus: data.result.validatedStatus,
          }));
        } else if (param === "active") {
          setStatsData((prev) => ({
            ...prev,
            activeStatus: data.result.activeStatus,
          }));
        }
        setStatsData((prev) => ({ ...prev, showClients: param }));
      })
      .catch((err) => console.log(err));
  };

  const getAllWorkers = () => {
    fetch(`${BASE_URL}adm.workers`, {
      method: "GET",
      headers: { Authorization: `Bearer ${adminData.uid}` },
    })
      .then((res) => res.json())
      .then((data) => {
        setClientData((prev) => ({
          ...prev,
          workers: data.result,
          filteredWorkers: data.result,
        }));
      })
      .catch((err) => console.log(err));
  };

  const getAllEmployers = () => {
    fetch(`${BASE_URL}adm.employers`, {
      method: "GET",
      headers: { Authorization: `Bearer ${adminData.uid}` },
    })
      .then((res) => res.json())
      .then((data) => {
        setClientData((prev) => ({
          ...prev,
          employers: data.result,
          filteredEmployers: data.result,
        }));
      })
      .catch((err) => console.log(err));
  };

  const getJobsData = () => {
    fetch(`${BASE_URL}adm.jobs`, {
      method: "GET",
      headers: { Authorization: `Bearer ${adminData.uid}` },
    })
      .then((res) => res.json())
      .then((data) => {
        setStatsData((prev) => ({
          ...prev,
          jobStatus: data.result.jobsStatus,
          jobsTimeState: data.result.jobsTimeState,
          jobsTypes: data.result.jobsTypes,
          top10jobs: data.result.top10_jobsCategories,
          totalJobs: data.result.totalJobs,
        }));
      })
      .catch((err) => console.log(err));
  };

  const fetchStatsData = (date_start, date_end) => {
    if (!date_start || !date_end) return;
    fetch(
      `${BASE_URL}adm.graph01?source=graph01&date_start=${date_start}&date_end=${date_end}`,
      {
        method: "GET",
        headers: { Authorization: `Bearer ${adminData.uid}` },
      }
    )
      .then((res) => res.json())
      .then((data) => {
        setChartData((prev) => ({
          ...prev,
          fetchedData: data.result,
        }));
      })
      .catch((err) => console.error(err));
  };

  // ---------------------- Initial Load ----------------------
  useEffect(() => {
    getAllClients("all");
    getAllWorkers();
    getAllEmployers();
    getJobsData();
  }, []);

  // ---------------------- Update Chart on Date Change ----------------------
  useEffect(() => {
    if (chartData.date_start && chartData.date_end) {
      // actualiza días
      const daysArray = getDaysArray(chartData.date_start, chartData.date_end);
      setChartData((prev) => ({ ...prev, days: daysArray }));

      // fetch datos del gráfico
      fetchStatsData(chartData.date_start, chartData.date_end);
    }
  }, [chartData.date_start, chartData.date_end]);

  return (
    <div className="py-12 md:px-12 flex flex-col w-full">
      <div className="flex items-center gap-8 justify-start">
        <People className="h-10 w-fit" />
        <p className="font-bold tracking-wider">ANALYTICS</p>
      </div>

      <div className="md:px-4 mt-4">
        <Statistics
          statsData={statsData}
          setStatsData={setStatsData}
          getAllClients={getAllClients}
          chartData={chartData}
          setChartData={setChartData}
          clientData={clientData}
        />
      </div>
    </div>
  );
};

export default ControlDashboard;
